import ProductPrice from '@stone/components/product/ProductPrice';
// import analytics from '@utils/analytics';
import api from '@utils/api';
import { getColorVariations, getSizeVariations } from '@utils/product';
import React, { Suspense, useMemo, useState, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import ProductReserveInBoutique from '@stone/components/reserve/ProductActionReserveInBoutique';
import ProductWishlistToggle from '@stone/components/product/ProductWishlistToggle';
import ProductLabels from '@stone/components/product/ProductLabels';
import ProductSelectionSizesExpanded from '@stone/components/product/ProductSelectionSizesExpanded';
import { useTranslation } from 'react-i18next';
import ProductButton from '@stone/components/product/ProductButton';
import useMediaQueries from '@stone/hooks/useMediaQueries';
import ProductSelectionColorPDP from './ProductSelectionColorPDP';
import ProductStickyTray from '@stone/components/product/ProductStickyTray';
import Icon from '@stone/ui/icon/Icon';
import { createPortal } from 'react-dom';
import ProductServiceLinks from './ProductServiceLinks';
import { useHistory } from 'react-router';
import analytics from '@stone/utils/analytics';
import { requestProductDetailsOpen } from './ProductDetailsDialog';
import { InstalmentButton } from './ProductInstalmentDrawer';
import { siteUrl } from '@common/utils/urlutils';
import classNames from 'classnames';
import ProductShopTheLookInfo from './ProductShopTheLookInfo';
const ExpressPaymentsModal = React.lazy(() => import('@components/bag/ExpressPaymentsModal'));
const ProductSelection = (props) => {
    var _a, _b, _c, _d;
    let current;
    const inLook = !!props.currentLook;
    const forcedProduct = !!props.product;
    const history = useHistory();
    const expressProps = { termsandconditions: siteUrl('terms'), privacypolicy: siteUrl('privacy'), hideSummary: true, modalNoPadding: true, modalFullWidth: true };
    //* ANCHOR - CUSTOM HOOKS --------------------------------------------------------------------------------------------------------------------------------------
    const { t } = useTranslation();
    const { isDesktop, isWideDesktop, isReflow } = useMediaQueries();
    const buttonRef = useRef();
    const profile = useSelector((state) => state.product).userShoppingInfo;
    if (inLook) {
        current = props.currentLook;
    }
    else if (forcedProduct) {
        current = props.product;
    }
    else {
        current = useSelector((state) => state.product).current;
    }
    const variantSizeObj = useMemo(() => (props.size ? JSON.parse(props.size) : undefined), [props.size]);
    // ANCHOR - STATES --------------------------------------------------------------------------------------------------------------------------------------------
    const [currentSize, setCurrentSize] = useState();
    const [variantPrice, setVariantPrice] = useState(((_b = (_a = variantSizeObj === null || variantSizeObj === void 0 ? void 0 : variantSizeObj.price) === null || _a === void 0 ? void 0 : _a.sales) === null || _b === void 0 ? void 0 : _b.value) ? variantSizeObj.price : undefined);
    const [currentColor, setCurrentColor] = useState();
    const [sizeSelectorError, setSizeSelectorError] = useState(false);
    // ANCHOR - USE EFFECT --------------------------------------------------------------------------------------------------------------------------------------------
    useEffect(() => {
        const colorSelected = getColorVariations(current).find((v) => v.selected);
        if (colorSelected) {
            setCurrentColor(colorSelected);
            if (currentColor && currentSize) {
                onSizeSelection(currentSize.id, true);
            }
        }
    }, [current, currentSize]);
    //log profile
    useEffect(() => {
        console.log('profile', profile);
    }, [profile]);
    // ANCHOR - FUNCTIONS ------------------------------------------------------------------------------------------------------------------------------------------
    const sendAnalytics = (context) => {
        analytics.addToBag(current, currentSize, variantPrice, { detail: context });
    };
    const changeColor = (colorVariation) => {
        if (!colorVariation) {
            return;
        }
        if (!inLook) {
            history.push(colorVariation.route);
        }
    };
    const changeSize = (variation, blockAnalytics) => {
        setCurrentSize(variation);
        // qui non va cambiato il prodotto, va solo salvata la taglia selezionata che serve per l'add to cart
        if ((current === null || current === void 0 ? void 0 : current.price.type) === 'range') {
            // prezzo diverso per taglia
            api.variantPrice(`${current === null || current === void 0 ? void 0 : current.masterId}${currentColor.id}${variation.id}`).then((data) => {
                setVariantPrice(data);
                if (!blockAnalytics) {
                    analytics.productDetailChange(current, variation, data);
                }
            });
        }
        else {
            if (!blockAnalytics) {
                analytics.productDetailChange(current, variation);
            }
        }
    };
    const onSizeSelection = (size, blockAnalytics) => {
        if (size) {
            let sizeVariation = sizeVariations.find((s) => s.id == size);
            if (sizeVariation) {
                changeSize(sizeVariation, blockAnalytics);
            }
        }
    };
    const triggerSizeSelectionOpen = () => {
        let selectSize = document.querySelector('#PDP-size-selector .selector__menu--fieldset');
        setTimeout(() => {
            setSizeSelectorError(true);
            selectSize.focus();
        }, 0);
    };
    //* SECTION - USE MEMO --------------------------------------------------------------------------------------------------------------------------------------------
    const colourVariations = useMemo(() => {
        let colors;
        colors = getColorVariations(current).map((value) => {
            return Object.assign(Object.assign({}, value), { groupPid: (current === null || current === void 0 ? void 0 : current.masterId) + value.id });
        });
        if (inLook) {
            // non è possibile selezionare altri colori nel look
            colors = colors.filter((value) => value.selected);
        }
        return colors;
    }, [current, inLook]);
    const sizeVariations = useMemo(() => {
        let sizeVariations = getSizeVariations(current);
        if (sizeVariations.length == 1) {
            setCurrentSize(sizeVariations[0]);
        }
        else if (sizeVariations.find((el) => el.displayValue == (variantSizeObj === null || variantSizeObj === void 0 ? void 0 : variantSizeObj.size))) {
            setCurrentSize(sizeVariations.find((el) => el.displayValue == variantSizeObj.size));
        }
        else if (!sizeVariations.find((el) => el.id == (currentSize === null || currentSize === void 0 ? void 0 : currentSize.id))) {
            setCurrentSize(undefined);
        }
        // console.info('nascondo il messaggio di errore');
        setSizeSelectorError(false);
        return sizeVariations;
    }, [current]);
    const sizeError = useMemo(() => {
        if (sizeSelectorError && !currentSize) {
            return t('label.pleaseselectasize');
        }
    }, [sizeSelectorError, currentSize]);
    const lastItem = useMemo(() => {
        if (sizeVariations && currentSize) {
            const _currentSize = sizeVariations.find((variation) => variation.id === currentSize.id);
            if (_currentSize.ATS === 1) {
                return t('product.lastAvailable');
            }
        }
    }, [sizeVariations, currentSize]);
    const showReserveInBoutiqueButton = useMemo(() => {
        var _a;
        return !window.noboutiqueavailability &&
            !(current === null || current === void 0 ? void 0 : current.isOnlineExclusive) &&
            ((current === null || current === void 0 ? void 0 : current.notShoppable) || ((_a = current === null || current === void 0 ? void 0 : current.availability) === null || _a === void 0 ? void 0 : _a.isOutOfStock) || (current === null || current === void 0 ? void 0 : current.isBoutiqueExclusive) || (current === null || current === void 0 ? void 0 : current.isBoutiqueExclusivePDP));
    }, [currentSize, current]);
    const isReservable = useMemo(() => (showReserveInBoutiqueButton || window.unshoppable || (current === null || current === void 0 ? void 0 : current.notShoppable) || (current === null || current === void 0 ? void 0 : current.isBoutiqueExclusive) || (current === null || current === void 0 ? void 0 : current.isBoutiqueExclusivePDP)) && !current.isComingSoon, [showReserveInBoutiqueButton, current]);
    const addToBagAvailable = useMemo(() => {
        var _a, _b, _c, _d;
        return (!window.unshoppable &&
            (!(current === null || current === void 0 ? void 0 : current.isBoutiqueExclusive) || !(current === null || current === void 0 ? void 0 : current.isBoutiqueExclusivePDP)) &&
            (!currentSize || (currentSize === null || currentSize === void 0 ? void 0 : currentSize.selectable)) &&
            !((_a = current === null || current === void 0 ? void 0 : current.availability) === null || _a === void 0 ? void 0 : _a.isOutOfStock) &&
            (current === null || current === void 0 ? void 0 : current.isComingSoon) != 2 &&
            !(current === null || current === void 0 ? void 0 : current.notShoppable) &&
            (((_b = current === null || current === void 0 ? void 0 : current.price) === null || _b === void 0 ? void 0 : _b.type) || ((_d = (_c = current === null || current === void 0 ? void 0 : current.price) === null || _c === void 0 ? void 0 : _c.sales) === null || _d === void 0 ? void 0 : _d.value)));
    }, [current, currentSize]);
    const showReserveInBoutiqueLink = useMemo(() => !window.noboutiqueavailability && !(current === null || current === void 0 ? void 0 : current.isOnlineExclusive) && !(current === null || current === void 0 ? void 0 : current.isMbm), [showReserveInBoutiqueButton, current]);
    const expressCheckoutAvailable = useMemo(() => {
        var _a, _b, _c, _d;
        return (window.expressCheckoutPDP &&
            !window.isClothing &&
            !window.unshoppable &&
            (!(current === null || current === void 0 ? void 0 : current.isBoutiqueExclusive) || !(current === null || current === void 0 ? void 0 : current.isBoutiqueExclusivePDP)) &&
            !((_a = current === null || current === void 0 ? void 0 : current.availability) === null || _a === void 0 ? void 0 : _a.isOutOfStock) &&
            (current === null || current === void 0 ? void 0 : current.isComingSoon) != 2 &&
            !(current === null || current === void 0 ? void 0 : current.notShoppable) &&
            !(current === null || current === void 0 ? void 0 : current.isMbm) &&
            (((_b = current === null || current === void 0 ? void 0 : current.price) === null || _b === void 0 ? void 0 : _b.type) || ((_d = (_c = current === null || current === void 0 ? void 0 : current.price) === null || _c === void 0 ? void 0 : _c.sales) === null || _d === void 0 ? void 0 : _d.value)) &&
            !inLook &&
            !current.isPreview);
    }, [current, currentSize]);
    const limitColorLength = useMemo(() => {
        if (isDesktop) {
            return 5;
        }
        else {
            return 4;
        }
    }, [isDesktop]);
    const isReserveLinkShowable = useMemo(() => { var _a; return showReserveInBoutiqueLink && !inLook && !window.unshoppable && !((_a = current === null || current === void 0 ? void 0 : current.availability) === null || _a === void 0 ? void 0 : _a.preorder) && !window.isClothing; }, [showReserveInBoutiqueLink, inLook, current]);
    const PRODUCT_STATUS = useMemo(() => {
        var _a, _b;
        if (!(current === null || current === void 0 ? void 0 : current.signupSaleProduct)) {
            return 'DEFAULT';
        }
        else {
            if (profile === null || profile === void 0 ? void 0 : profile.guest) {
                return 'RESTRICTED_GUEST';
            }
            else {
                if (((_b = (_a = profile === null || profile === void 0 ? void 0 : profile.sale) === null || _a === void 0 ? void 0 : _a.saleSignupCountryCode) === null || _b === void 0 ? void 0 : _b.length) && profile.sale.saleSignupCountryCode !== window.country) {
                    return 'RESTRICTED_NOT_ELIGIBLE_DIFFERENT_COUNTRY';
                }
                else if (current.customerGroups.some((g) => profile === null || profile === void 0 ? void 0 : profile.customerGroups.includes(g))) {
                    return 'RESTRICTED_ELIGIBLE';
                }
                else {
                    return 'RESTRICTED_NOT_ELIGIBLE';
                }
            }
        }
    }, [current, profile]);
    // ANCHOR - SERVICE LINKS
    // const serviceLinksArray = useMemo(() => {
    //   // TODO - Waiting for additional service link indications
    //   const array: any[] = [
    //     // {
    //     //   //ORDER MANAGEMENT
    //     //   label: t('product.ordermanagement.label'),
    //     //   url: t('product.ordermanagement.url'),
    //     // },
    //     // {
    //     //   //AFTER CARE
    //     //   label: t('product.aftercare.label'),
    //     //   url: t('product.aftercare.url'),
    //     // },
    //   ];
    //   return array;
    // }, []);
    // const linksNeedShowMore = useMemo(() => {
    //   return isWideDesktop && serviceLinksArray?.length > 0;
    // }, [isWideDesktop, serviceLinksArray]);
    //!SECTION end useMemo
    //* ANCHOR - COMPONENTS ----------------------------------------------------------------------------------------------------------------------------------------
    const breadcrumb = (parentCategory) => {
        return (React.createElement("a", { href: parentCategory === null || parentCategory === void 0 ? void 0 : parentCategory.url, className: !inLook ? 'in-pdp' : '', "aria-label": `${t('label.backtoplp', [parentCategory === null || parentCategory === void 0 ? void 0 : parentCategory.htmlValue])}` },
            React.createElement("span", { "aria-hidden": "true" },
                "< ",
                (parentCategory === null || parentCategory === void 0 ? void 0 : parentCategory.htmlValue) || t('label.back'))));
    };
    // const renderStandardServices = (arr: { label: string; url: string }[]) =>
    // arr?.map((el) => (
    //   <a key={el.label} href={el.url} className="button button--tertiary">
    //     <span>{el.label}</span>
    //   </a>
    // ));
    // const renderAdditionalServices = (arr: { label: string; url: string }[]) =>
    //   arr?.map((el) => (
    //     <a key={el.label} href={el.url} className="button button--tertiary">
    //       <span>{el.label}</span>
    //     </a>
    //   ));
    const lineIconsContainer = (className) => {
        const breadcrumbs = (current === null || current === void 0 ? void 0 : current.breadcrumbs) || [];
        const parentCategory = breadcrumbs[breadcrumbs.length - 1];
        return (React.createElement("div", { className: className },
            React.createElement("div", { className: "product-selection__breadcrumb" }, breadcrumb(parentCategory)),
            !inLook && (React.createElement("div", { className: "product-selection__line-labels" },
                React.createElement(ProductLabels, { product: current })))));
    };
    const renderButtons = () => (React.createElement(React.Fragment, null,
        !window.unshoppable && (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "product-selection__ctas", ref: props.ctasRef },
                React.createElement(ProductButton, { inPDP: props.inPDP, current: current, currentSize: currentSize, currentColor: currentColor, colourVariations: colourVariations, sizeVariations: sizeVariations, triggerOpenSize: triggerSizeSelectionOpen, trackAddToBag: () => sendAnalytics('product selection'), showReserveInBoutiqueButton: showReserveInBoutiqueButton, inShopTheLook: props.shopTheLook, inverted: props.inverted, productStatus: PRODUCT_STATUS }),
                currentColor && !(current === null || current === void 0 ? void 0 : current.isMbm) && !(props === null || props === void 0 ? void 0 : props.currentLook) && !(current === null || current === void 0 ? void 0 : current.isBoutiqueExclusive) && !(current === null || current === void 0 ? void 0 : current.isBoutiqueExclusivePDP) && PRODUCT_STATUS === 'DEFAULT' && (React.createElement(ProductWishlistToggle, { color: "black", productSize: currentSize, productColor: currentColor, product: current, section: "pdp", modifierClass: "button button--icon" }))),
            expressCheckoutAvailable &&
                addToBagAvailable &&
                (((current === null || current === void 0 ? void 0 : current.unlock) && window.loggedin) || !current.unlock) &&
                !(current === null || current === void 0 ? void 0 : current.isBoutiqueExclusive) &&
                !(current === null || current === void 0 ? void 0 : current.isBoutiqueExclusivePDP) &&
                (PRODUCT_STATUS === 'DEFAULT' || PRODUCT_STATUS === 'RESTRICTED_ELIGIBLE') && (React.createElement("div", { className: "product-selection__ctas" },
                React.createElement(Suspense, { fallback: React.createElement(React.Fragment, null) },
                    React.createElement(ExpressPaymentsModal, Object.assign({ currentId: current.id, size: currentSize, triggerOpenSize: triggerSizeSelectionOpen }, expressProps))))),
            PRODUCT_STATUS.startsWith('RESTRICTED_NOT_ELIGIBLE') && (React.createElement("a", { href: t('product.sale.continueshoppingurl'), className: "button button--secondary full" },
                React.createElement("span", null, t('button.continueshopping')))))),
        isReservable && currentColor && PRODUCT_STATUS === 'DEFAULT' && (React.createElement("div", { className: "product-selection__ctas" },
            React.createElement(ProductReserveInBoutique, { product: current, size: currentSize, color: currentColor, sizeVariations: sizeVariations, colourVariations: colourVariations, buttonType: "secondary" })))));
    //* SECTION - RENDER --------------------------------------------------------------------
    return (React.createElement(React.Fragment, null,
        !inLook &&
            props.imageLoaded &&
            addToBagAvailable &&
            !isReflow &&
            createPortal(React.createElement(ProductStickyTray, { current: current, currentColor: currentColor, changeColor: changeColor, currentSize: currentSize, changeSize: changeSize, colourVariations: colourVariations, sizeVariations: sizeVariations, sizeSelectorError: sizeSelectorError, updateSizeSelectorError: (e) => setSizeSelectorError(e), variantPrice: variantPrice, trackAddToBag: () => sendAnalytics('sticky tray'), showReserveInBoutiqueButton: showReserveInBoutiqueButton, setSizeguideOpen: props === null || props === void 0 ? void 0 : props.setSizeguideOpen, isPdp: props.isPdp, productStatus: PRODUCT_STATUS }), document.querySelector('#catalog')),
        React.createElement("div", { className: "product-selection__heading--placeholder" },
            React.createElement("div", { className: "product-selection__heading" },
                (!inLook || (current === null || current === void 0 ? void 0 : current.unlock)) && lineIconsContainer('product-selection__line'),
                React.createElement("div", { className: "product-selection__maininfo" },
                    React.createElement("h1", { className: "product-selection__name" }, current === null || current === void 0 ? void 0 : current.productName),
                    (current === null || current === void 0 ? void 0 : current.seoName) && React.createElement("h2", { className: "product-selection__seoname font__labelling" }, current === null || current === void 0 ? void 0 : current.seoName),
                    React.createElement("div", { className: "product-selection__description" },
                        React.createElement("p", null, (current === null || current === void 0 ? void 0 : current.shortDescription) || (current === null || current === void 0 ? void 0 : current.longDescription)),
                        (current === null || current === void 0 ? void 0 : current.additionalShortDescription) && React.createElement("p", { dangerouslySetInnerHTML: { __html: current.additionalShortDescription }, className: "mt-16" }),
                        current.longDescription && (
                        //add long description hidden for seo purpose
                        React.createElement("p", { className: "d-none" }, current.longDescription))),
                    React.createElement("button", { onClick: (e) => {
                            requestProductDetailsOpen(null, e);
                        }, "aria-haspopup": "dialog", className: "button button--tertiary product-details__button" },
                        React.createElement("span", null, t('product.details'))),
                    React.createElement("span", { className: "product-selection__price" },
                        React.createElement(ProductPrice, { price: variantPrice || (current === null || current === void 0 ? void 0 : current.price), promotions: current.promotions, inline: true, showCurrency: true })),
                    React.createElement("div", { className: "product-selection__instolment mt-8" },
                        React.createElement(InstalmentButton, null))))),
        React.createElement("div", { className: "product-selection__selectors" },
            React.createElement("div", { className: "selector-color" },
                React.createElement("div", { className: "selector__header" },
                    React.createElement("span", { className: "selector__label" },
                        React.createElement("span", { className: "selector__label__name" }, t('product.colorlabel')),
                        (currentColor === null || currentColor === void 0 ? void 0 : currentColor.displayValue) && React.createElement("span", { className: "selector__label__value" }, currentColor.displayValue)),
                    (colourVariations === null || colourVariations === void 0 ? void 0 : colourVariations.length) > limitColorLength && !isWideDesktop && (React.createElement("div", { className: "selector-navigation" },
                        React.createElement("button", { className: "selector-prev selector-prev-pdpcolor selector-button", tabIndex: -1, "aria-hidden": true },
                            React.createElement(Icon, { family: "10", name: "left-chevron" })),
                        React.createElement("button", { className: "selector-next selector-next-pdpcolor selector-button", tabIndex: -1, "aria-hidden": true },
                            React.createElement(Icon, { family: "10", name: "right-chevron" }))))),
                React.createElement(ProductSelectionColorPDP, { variationValues: colourVariations, currentId: currentColor === null || currentColor === void 0 ? void 0 : currentColor.id, onChangeVariation: (colorVariation) => {
                        changeColor(colorVariation);
                    }, className: 'inpdp', productUuid: current.masterId, isBoutiqueExclusive: current === null || current === void 0 ? void 0 : current.isBoutiqueExclusive })),
            (PRODUCT_STATUS === 'DEFAULT' || PRODUCT_STATUS === 'RESTRICTED_ELIGIBLE') && (React.createElement(ProductSelectionSizesExpanded, { wrapperId: "PDP-size-selector", className: "inpdp", contactformurl: props === null || props === void 0 ? void 0 : props.contactformurl, variationValues: sizeVariations, current: current, currentId: currentSize === null || currentSize === void 0 ? void 0 : currentSize.id, onChangeVariation: (sizeVariation) => {
                    changeSize(sizeVariation);
                    // analytics.selectedSize(sizeVariation.displayValue, current.masterId);
                }, error: sizeError, 
                // trackOpenSize={() => analytics.openSize(current?.masterId)}
                onSizeSelection: onSizeSelection, setSizeguideOpen: props === null || props === void 0 ? void 0 : props.setSizeguideOpen, sizeguideOpen: props === null || props === void 0 ? void 0 : props.sizeguideOpen, inverted: props.inverted, inPdp: true, lastItem: lastItem, isFullyOutOfStock: (_c = current === null || current === void 0 ? void 0 : current.availability) === null || _c === void 0 ? void 0 : _c.isOutOfStock, showSizeFit: true })),
            React.createElement(React.Fragment, null,
                PRODUCT_STATUS !== 'DEFAULT' && (React.createElement("div", { className: classNames('product-selection__helpertext', {
                        errors: PRODUCT_STATUS.startsWith('RESTRICTED_NOT_ELIGIBLE') || sizeError,
                        sizesShown: PRODUCT_STATUS === 'RESTRICTED_ELIGIBLE',
                    }) },
                    React.createElement("p", { dangerouslySetInnerHTML: { __html: t('product.sale.ctahelpertext') } }))),
                sizeError && (React.createElement("div", { className: "selector__error" },
                    React.createElement(Icon, { name: "alert", family: "10" }),
                    React.createElement("span", { className: "errormessage", role: "alert" }, sizeError))),
                PRODUCT_STATUS.startsWith('RESTRICTED_NOT_ELIGIBLE') && !sizeError && (React.createElement("div", { className: "selector__error" },
                    React.createElement(Icon, { name: "alert", family: "10" }),
                    React.createElement("span", { className: "errormessage", role: "alert", dangerouslySetInnerHTML: {
                            __html: PRODUCT_STATUS === 'RESTRICTED_NOT_ELIGIBLE_DIFFERENT_COUNTRY'
                                ? t('product.sale.restrictednoteligiblecountry', { 0: t(`countrycode.${(_d = profile.sale) === null || _d === void 0 ? void 0 : _d.saleSignupCountryCode}`) })
                                : t('product.sale.restrictednoteligible'),
                        } }))),
                React.createElement("div", { ref: buttonRef }, renderButtons())),
            React.createElement(ProductServiceLinks, { current: current, currentSize: currentSize, currentColor: currentColor, sizeVariations: sizeVariations, colourVariations: colourVariations, isReserveLinkShowable: isReserveLinkShowable, setSizeGuideOpen: props === null || props === void 0 ? void 0 : props.setSizeguideOpen }),
            React.createElement(ProductShopTheLookInfo, { current: current }))));
};
ProductSelection.defaultProps = {
    imageLoaded: true,
};
export default ProductSelection;
